import { useState } from 'react'
import { useParams } from 'react-router'
import { useAuthForm } from '@/hooks/auth/useAuthForm'
import { resetPasswordService } from '@/services/auth'

type NewPasswordFormData = {
  new_password: string
  confirmPassword: string
}

const useForm = () => {
  const [showConfirmation, setShowConfirmation] = useState(false)
  const { token } = useParams() as { token: string };

  const authForm = useAuthForm<void, NewPasswordFormData>({
    mutationFn: ({ confirmPassword: _discard, new_password }) => resetPasswordService({ new_password, token: token! }),
    onSuccess: () => setShowConfirmation(true),
  })

  return { ...authForm, showConfirmation }
}

export default useForm
